import Vue from "vue";

Vue.prototype.$helper = {
  status: (params) => {
    if (params) return "Active";
    else return "Inactive";
  },
};
